import { SxProps, Theme } from '@mui/material'

export const DataGridInactiveRowCssClassId = 'data-grid-inactive-row'

export const DataGridDisabledStyled: SxProps<Theme> = {
  // disable everything in row except column for actions
  '& .MuiDataGrid-row.data-grid-inactive-row .MuiDataGrid-cell:not([data-field="actions"])': {
    opacity: '0.3',
  },
}
